import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { hotComics } from "@/mocks/comics";

const comicPages = [
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20scene%2C%20beautiful%20illustration%20with%20speech%20bubbles%20and%20panels%2C%20clean%20line%20art%2C%20detailed%20character%20artwork%2C%20manga%20style%2C%20warm%20color%20palette%2C%20professional%20webtoon%20artwork%2C%20emotional%20opening%20scene&width=800&height=1200&seq=comic-page-1&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20panel%2C%20character%20interaction%20scene%2C%20detailed%20illustration%20with%20dialogue%20bubbles%2C%20expressive%20faces%2C%20warm%20lighting%2C%20webtoon%20style%20artwork%2C%20clean%20background&width=800&height=1200&seq=comic-page-2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20action%20scene%2C%20dynamic%20character%20pose%2C%20detailed%20line%20art%2C%20dramatic%20lighting%20effects%2C%20speech%20bubbles%2C%20professional%20webtoon%20quality%2C%20warm%20tones&width=800&height=1200&seq=comic-page-3&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20emotional%20scene%2C%20character%20closeup%20with%20detailed%20expression%2C%20soft%20lighting%2C%20thought%20bubbles%2C%20manga%20panel%20composition%2C%20warm%20color%20scheme&width=800&height=1200&seq=comic-page-4&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20landscape%20scene%2C%20beautiful%20background%20with%20characters%2C%20detailed%20environment%20art%2C%20soft%20atmospheric%20lighting%2C%20webtoon%20style%20illustration%2C%20cream%20and%20amber%20palette&width=800&height=1200&seq=comic-page-5&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20climactic%20scene%2C%20intense%20character%20interaction%2C%20dramatic%20composition%2C%20detailed%20illustration%2C%20speech%20bubbles%2C%20professional%20webtoon%20artwork%2C%20warm%20lighting&width=800&height=1200&seq=comic-page-6&orientation=portrait",
];

export default function ComicRead() {
  const { id } = useParams<{ id: string }>();
  const comic = hotComics.find((c) => c.id === id);

  if (!comic) {
    return (
      <>
        <Navbar />
        <main className="pt-20 min-h-[60vh] flex items-center justify-center bg-background-50">
          <div className="text-center">
            <i className="ri-emotion-sad-line text-5xl text-foreground-400 mb-4 block" />
            <p className="text-foreground-600 text-lg mb-4">未找到该漫画</p>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              返回分类
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="bg-background-950 min-h-screen">
        <div className="fixed top-16 left-0 right-0 z-40 bg-background-950/95 backdrop-blur border-b border-background-900/60 px-4 md:px-6 py-3 flex items-center justify-between">
          <Link
            to={`/comic/${comic.id}`}
            className="flex items-center gap-2 text-background-50/80 hover:text-background-50 text-sm transition-colors"
          >
            <i className="ri-arrow-left-line" />
            {comic.title}
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-background-50/50 text-xs">
              第 1 / {comic.chapterCount} 话
            </span>
            <button
              type="button"
              className="text-background-50/60 hover:text-background-50 text-sm transition-colors"
              aria-label="设置"
            >
              <i className="ri-settings-3-line" />
            </button>
          </div>
        </div>

        <div className="pt-32 pb-20 max-w-2xl mx-auto px-4 space-y-0">
          {comicPages.map((url, i) => (
            <div key={i} className="w-full bg-background-900 rounded-none overflow-hidden">
              <img
                src={url}
                alt={`${comic.title} - 第 ${i + 1} 页`}
                className="w-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <div className="fixed bottom-0 left-0 right-0 bg-background-950/95 backdrop-blur border-t border-background-900/60 px-4 py-3 flex items-center justify-center gap-4">
          <button
            type="button"
            className="flex items-center gap-1.5 bg-background-800 hover:bg-background-700 text-background-50 text-sm px-4 py-2 rounded-lg transition-colors"
          >
            <i className="ri-arrow-left-line" />
            上一话
          </button>
          <span className="text-background-50/40 text-xs mx-2">第 1 话</span>
          <button
            type="button"
            className="flex items-center gap-1.5 bg-accent-500 hover:bg-accent-600 text-background-50 text-sm px-4 py-2 rounded-lg transition-colors"
          >
            下一话
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </main>
      <Footer />
    </>
  );
}